import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useBreadcrumbs, useUser } from '../hooks';
import { Header, Table, Button, Pagination, Toast, Label } from 'react-frontier';
import { Expense } from '../SiteClasses';
import { addCommas } from '../SiteUtil';
import UserAccess from '../UserAccess';
import classNames from 'classnames';
import moment from 'moment';
import API from '../API';

interface PendingExpensesProps{
	
}

const PAGE_SIZE = 20;

var PendingExpenses = (props: PendingExpensesProps)=>{
	var { t } = useTranslation();
	var { setTitle } = useBreadcrumbs();
	var { hasAccess } = useUser();
	var [loadError, setLoadError] = useState<string>(null);
	var [expenses, setExpenses] = useState<Expense []>(null);
	var [page, setPage] = useState<number>(0);
	var [loading, setLoading] = useState<boolean>(false);
	var [selectedExpenses, setSelectedExpenses] = useState<number[]>([]);

	useEffect(()=>{
		setTitle('Gastos pendientes');
		get();
	}, []);
	
	var get = (get_page?: number)=>{
		var offset = (get_page > 0) ? Math.max(0, (get_page || page) * PAGE_SIZE) : 0;
		
		setLoading(true);
		API.getExpenses(PAGE_SIZE, offset, true).then(res=>{
			if(res.error) return setLoadError(res.message);
			return setExpenses(res.data);
		}).catch(err=>{
			return setLoadError('Hubo un error al obtener los gastos pendientes. (GES-1)');
		}).finally(()=>{
			setLoading(false);
		})
	};

	var onPageChange = (page: number)=>{
		setLoading(true)
		setPage(page);
		get(page);
	}

	var addExpense = (expense_id: number)=>{
		return ()=>{
			var e = [...selectedExpenses];
			var ix = e.indexOf(expense_id);
			if(ix==-1){
				e.push(expense_id);
			}else{
				e = e.filter(a=>a!==expense_id);
			}
			setSelectedExpenses(e);
		}
	};

	var onApprove = ()=>{
		setLoading(true);
		API.approveExpense(selectedExpenses).then(res=>{
			if(res.error) return setLoadError(res.message);
			Toast.success('Gastos aprobados!');

			var newExpenses = expenses.filter(expense => !selectedExpenses.includes(expense.expense_id));
			setExpenses(newExpenses);
			setSelectedExpenses([]);
		}).catch(err=>{
			setLoadError('Hubo un error al aprobar los gastos. (LCL-1)');
		}).finally(()=>{
			setLoading(false);
		});
	};
	
	if(loadError) { return <Header text='Error' subtext={loadError} />};
	if(!expenses) { return <Header text='Cargando datos' loading/> };

	return <div>
		<Table
			title='Gastos Pendientes'
			style={{ maxWidth: 800, margin: 'auto', marginTop: 20 }}
			headers={['','ID', 'Evento', 'Titulo', 'Tipo', 'Departamento', 'Creado', 'Monto']}
			centeredIndexes={[5]}
			emptyText={expenses.length === 0 && 'No hay gastos pendientes.'}
			footer={(expenses.length >= PAGE_SIZE || page !== 0) && (
				<Table.Cell colSpan={10} row>
					<div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
						<Pagination page={page} onPageChange={onPageChange} hasNext={expenses.length >= PAGE_SIZE} />
					</div>
				</Table.Cell>
			)}
			button={hasAccess(UserAccess.EVENTS.APPROVE_EXPENSE) ? (
				<Button text='Aprobar' size='small' color='black' onClick={onApprove} disabled={selectedExpenses.length === 0}/>
			) : undefined}
		>
			{loading ? (
				<Table.Cell row className='empty' colSpan={8}>
					<Header loading text='Cargando datos' />
				</Table.Cell>
			) : expenses.map(e=>{
				var selected = selectedExpenses.indexOf(e.expense_id)>-1;
				return (
					<Table.Row
						key={`EXPS-${e.expense_id}`}
						selectable
						onClick={addExpense(e.expense_id)}
						collapsingIndexes={[0, 1, 2, 3, 5, 6, 7]}
						data={[
							<i style={{ fontSize: 20, margin: 0 }} className={classNames('icon circle', {
								'check': selected,
								outline: !selected,
							})}></i>,
							e.expense_id,
							e.event_name,
							e.expense_title,
							e.type_name,
							e.department_name ? <Label>{e.department_name}</Label> : <Label>-</Label>,
							moment.unix(e.date_created).format('DD/MM/YY HH:mm'),
							addCommas(e.amount),
						]}
					/>
				)
			})}
		</Table>
	</div>
}

export default PendingExpenses;